import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import { clsx } from 'clsx';

import { ETab } from '../../../types/tab';
import * as style from './style.css';

interface ITabProps {
  title: string;
  isActive: boolean;
  count?: number;
  value: ETab;
  onClick(value: ETab): void;
}

export const Tab = ({ title, isActive, count, onClick, value }: ITabProps) => {
  return (
    <div
      onClick={() => onClick(value)}
      className={clsx(style['tab'], {
        [style['active']]: isActive,
      })}
    >
      <UIText2 color={isActive ? 'text-main-default' : 'text-primary-default'} display="inline" fontWeight="bold">
        {title}
      </UIText2>
      &nbsp;
      <UIText2 color="gray40_100" display="inline">
        {count}
      </UIText2>
    </div>
  );
};
